import { PartialId } from '@attain-apps/string-builder'

import * as core from '../../../../../../../../../core'
import * as organization from '../../../../organization'
import * as entry from '../entry'

export const RESOURCE = {
  payload: {
    canBeOptional: true,
    context: core.dms.models.Attribute.Id.Context.from({
      context: entry.RESOURCE.payload.dimension.partialId,
      partialId: entry.RESOURCE.payload.partialId,
      type: core.dms.models.Type.Entity,
    }),
    description: 'Associated organizational unit',
    isOptional: true,
    name: 'Organization',
    partialId: PartialId.Standard.create('org'),
    type: {
      dimensionId: core.dms.models.Dimension.Id.from(
        organization.RESOURCE.payload,
      ),
    },
  },
  type: core.quiver.Resource.Type.DmsAttribute,
} as const satisfies core.quiver.Resource<core.quiver.Resource.Type.DmsAttribute>
